import styled from 'styled-components';
const S = {};

const LightTextColor = ({ theme: { $iwgLightTextColor } }) => `${$iwgLightTextColor}`;
const DarkTextColor = ({ theme: { $iwgDarkTextColor } }) => `${$iwgDarkTextColor}`;
const PrimaryColor = ({ theme: { $iwgMainColor } }) => `${$iwgMainColor}`;
const SecondaryColor = ({ theme: { $iwgSecondaryColor } }) => `${$iwgSecondaryColor}`;
const RedColor = ({ theme: { $iwgRedTextColor } }) => `${$iwgRedTextColor}`;
const GreenColor = ({ theme: { $iwgGreenTextColor } }) => `${$iwgGreenTextColor}`;
const BalanceBgColor = ({ theme: { $iwgBalanceBgColor } }) => `${$iwgBalanceBgColor}`;

S.InstantWinGamesTopTab = styled.div`
  display: flex;
  width: 100%;
  margin-top: 0.25rem;
`;

S.BalanceWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  width: 100%;
  height: 3.75rem;
  padding: 0.75rem 1.5rem;
  background-color: ${SecondaryColor};
  color: ${DarkTextColor};
  font-weight: 700;
  font-size: 1rem;
`;

S.BalanceBox = styled.div`
  min-width: 10rem;
  border-radius: 4px;
  padding: 0.3rem 0;
  padding-right: 0.5rem;
  background-color: ${DarkTextColor};
  font-size: 14px;
  text-align: right;
  color: ${LightTextColor};
`;

S.PaymentBalanceInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: ${SecondaryColor};
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
`;

S.PaymentSessionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: ${(props) => (props.isSessionActive ? GreenColor : RedColor)};
`;

S.PaymentBalanceWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.7rem;
`;

S.PaymentBalanceBox = styled.div`
  min-width: 10rem;
  border-radius: 4px;
  margin-left: 0.5rem;
  padding: 0.3rem 0;
  padding-right: 0.5rem;
  background-color: ${DarkTextColor};
  font-size: 14px;
  text-align: right;
  color: ${LightTextColor};
`;

S.InfoIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  margin-left: 0.83rem;
  border-radius: 50%;
  border: 0.17rem solid ${BalanceBgColor};
`;

S.DepositButton = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 16rem;
  height: 2rem;
  padding: 0 0.31rem 0 3.25rem;
  border-radius: 0.25rem;
  background-color: ${PrimaryColor};
  color: ${LightTextColor};
  cursor: pointer;
  font-weight: 700;
  font-size: 1rem;
`;

S.DepositIcon = styled.i`
  position: absolute;
  top: 0.31rem;
  bottom: 0;
  left: 0.63rem;
  margin: auto 0;
  width: 1.88rem;
  height: 1.88rem;
`;

export default S;
